"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var order_list_1 = require("../../../api/calls/order/order_list");
var main_1 = require("../../../reducers/slices/main");
var logo_png_1 = __importDefault(require("../../../assets/logo.png"));
var react_router_dom_1 = require("react-router-dom");
var OrdersPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _a = (0, react_1.useState)([]), orderList = _a[0], setOrderList = _a[1];
    var _b = (0, react_1.useState)(false), isLoading = _b[0], setIsLoading = _b[1];
    var lastOrder = orderList ? orderList[orderList.length - 1] : [];
    (0, react_1.useEffect)(function () {
        if (user) {
            setIsLoading(true);
            (0, order_list_1.order_list)().then(function (response) {
                setIsLoading(false);
                if (response.success) {
                    setOrderList(response.content.order_list);
                }
                else {
                    dispatch((0, main_1.setMainModal)({
                        title: "Could not get order list!",
                        messages: [response.message],
                    }));
                }
            });
        }
    }, [user]);
    return (react_1.default.createElement("div", { className: "pt-4" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
            react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Orders", size: "3xlarge", textColor: "text-secondary" }),
                orderList && orderList.length > 0 ? (orderList.map(function (order, index) {
                    var _a, _b;
                    // console.log("order", order);
                    return (react_1.default.createElement("div", { onClick: function () {
                            navigate("/order/details/".concat(order._id));
                        } },
                        react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "shadow hover:shadow-lg transition-shadow cursor-pointer", borderColor: "border-transparent" },
                            react_1.default.createElement("div", { key: index, className: "flex flex-row items-center gap-4" },
                                react_1.default.createElement("div", { className: "hidden lg:block" },
                                    react_1.default.createElement(doshx_controls_web_1.LogoControl, { image: logo_png_1.default, size: "small" })),
                                react_1.default.createElement("div", { className: "flex-1 flex flex-col" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "cursor-pointer", label: "Order #".concat(order.code), bold: true, size: "medium", textColor: "text-secondary" }),
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "cursor-pointer", label: lastOrder.length ? (_a = lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.branch) === null || _a === void 0 ? void 0 : _a.display_name : "" }),
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "cursor-pointer", label: "".concat((_b = order === null || order === void 0 ? void 0 : order.product_list) === null || _b === void 0 ? void 0 : _b.length, " Items") })),
                                react_1.default.createElement("div", { className: "flex flex-col lg:flex-row gap-4" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "cursor-pointer", label: doshx_controls_web_1.Utilities.formatDateTime(order.createdAt), bold: true, textColor: "text-secondary" }),
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "cursor-pointer", label: order.status }))))));
                })) : isLoading ? (react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "large" })) : (react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "You dont have any orders! Add items to your cart and checkout.", size: "medium", textColor: "text-secondary" }))))));
};
exports.OrdersPage = OrdersPage;
